import { convertToDotString, convertToRelativeString } from '@diritto/common/utils/date';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

export const RelativeDateText = ({
  className,
  children,
  date,
  tagName,
}: {
  className?: string;
  date: Date;
  tagName?: string;
  children?: ReactNode;
}) => {
  if (tagName) {
    const NewTag = StyledWrapper.withComponent(tagName as any);
    return (
      <NewTag className={className} title={convertToDotString(date)} suppressHydrationWarning>
        {convertToRelativeString(date)}
        {children}
      </NewTag>
    );
  }

  return (
    <StyledWrapper className={className} title={convertToDotString(date)} suppressHydrationWarning>
      {convertToRelativeString(date)}
      {children}
    </StyledWrapper>
  );
};

const StyledWrapper = styled.p``;
